import React, { Suspense } from 'react'
import { Outlet } from 'react-router'
import { ConfigProvider } from 'antd'
import { styled } from 'styled-components'
import Footer from '../components/GlobalFooter/AppFooter'
import { ReactComponent as Logo } from '../assets/finadeck-logo-web.svg'
import { ReactComponent as AccountorLogo } from '../assets/accountor/accountor_logo.svg'
import RantalainenLogo from '../assets/rantalainen/rantalainen.png'

const StyledUserLayout = styled.div`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f7f8fb;
  color: #0b0d14;

  /* Soft blue glow from the top */
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: -280px;
    width: 900px;
    height: 540px;
    transform: translateX(-50%);
    border-radius: 50%;
    background: radial-gradient(closest-side, rgba(58, 96, 255, 0.28), rgba(58, 96, 255, 0));
    pointer-events: none;
  }

  /* Faint grid that fades out from the centre */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(2, 37, 161, 0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(2, 37, 161, 0.06) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse at 50% 30%, #000 0%, transparent 70%);
    pointer-events: none;
  }

  .content,
  .user-footer {
    position: relative;
    z-index: 1;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 24px 16px;
  }

  .login-card {
    width: 100%;
    max-width: 380px;
    padding: 32px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0.85));
    border: 1px solid rgba(11, 13, 20, 0.08);
    border-radius: 14px;
    box-shadow: 0 30px 60px -24px rgba(2, 37, 161, 0.25), 0 2px 6px rgba(11, 13, 20, 0.04), inset 0 1px 0 #ffffff;
  }

  @media (max-width: 480px) {
    .login-card {
      padding: 24px;
    }
  }

  .login-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-left: -18px;
  }

  .logo-text {
    font-size: 40px;
    line-height: 1;
    font-family: 'Manrope';
    font-weight: 500;
    color: #0225a1;
  }
`

const UserLayout: React.FC<any> = props => {
  const { children } = props

  // Near-black primary button that lightens slightly on hover
  const buttonTheme = { colorPrimary: '#0b0d14', colorPrimaryHover: '#2e3240', colorPrimaryActive: '#000000' }

  const renderLogo = () => {
    if (window.location.hostname === 'accountor.finadeck.fi')
      return <AccountorLogo style={{ height: 42, marginLeft: 10 }} />
    if (window.location.hostname === 'rantalainen.finadeck.fi')
      return <img src={RantalainenLogo} alt="RantalainenLogo" style={{ height: '64px' }} />
    return (
      <>
        <Logo style={{ height: 52 }} />
        <span className="logo-text">finadeck</span>
      </>
    )
  }

  return (
    <StyledUserLayout className="user-layout">
      <div className="lang">{/* <SelectLang /> */}</div>
      <div className="content">
        {/* No fallback: the card appears once the page and its translations are ready, so it doesn't change height */}
        <Suspense fallback={null}>
          <div className="login-header">{renderLogo()}</div>
          <ConfigProvider theme={{ components: { Button: buttonTheme } }}>
            <div className="login-card">
              <Outlet />
              {children}
            </div>
          </ConfigProvider>
        </Suspense>
      </div>
      <div className="user-footer">
        <Footer />
      </div>
    </StyledUserLayout>
  )
}

export default UserLayout
